var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25781 16.3184C3.53906 15.5996 4.01563 14.0918 3.64844 13.209C3.28125 12.3262 1.875 11.5527 1.875 10.5762C1.875 9.59961 3.26563 8.85742 3.64844 7.94336C4.03125 7.0293 3.53906 5.55273 4.25781 4.83398C4.97656 4.11523 6.48438 4.5918 7.36719 4.22461C8.25 3.85742 9.02344 2.45117 10 2.45117C10.9766 2.45117 11.7187 3.8418 12.6328 4.22461C13.5469 4.60742 15.0234 4.11523 15.7422 4.83398C16.4609 5.55273 15.9844 7.06055 16.3516 7.94336C16.7188 8.82617 18.125 9.59961 18.125 10.5762C18.125 11.5527 16.7344 12.2949 16.3516 13.209C15.9688 14.123 16.4609 15.5996 15.7422 16.3184C15.0234 17.0371 13.5156 16.5605 12.6328 16.9277C11.75 17.2949 10.9766 18.7012 10 18.7012C9.02344 18.7012 8.28125 17.3105 7.36719 16.9277C6.45313 16.5449 4.97656 17.0371 4.25781 16.3184Z",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 8.70117L8.85156 13.0762L6.5625 10.8887",
    stroke: "#969992",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeIco);
export default __webpack_public_path__ + "static/media/upgrade_ico.04aca3268a2265b0dc7de4d1bc7b0337.svg";
export { ForwardRef as ReactComponent };